import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { BusinessComplianceSettingForm } from 'src/app/classes/form-groups/business-compliance-setting-form';
import { Company } from 'src/app/classes/models';
import { UtilityService } from 'src/app/services/utility.service';

type BVCompanyBackgroundChecksMap = Map<
  string,
  {
    controlName: string;
    show: boolean;
    inputType: 'Select' | 'Checkbox';
    selectOptions?: any;
    checkBoxLabel?: 'Waive' | 'Required?' | 'Allowed?';
  }
>;

@Component({
  selector: 'app-compliance-business-verified-company-background-checks',
  templateUrl:
    './compliance-business-verified-company-background-checks.component.html',
  styleUrls: [
    './compliance-business-verified-company-background-checks.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceBusinessVerifiedCompanyBackgroundChecksComponent {
  constructor(private UtilityService: UtilityService) {}

  @Input() businessComplianceSettingForms?: BusinessComplianceSettingForm[];
  @Input() company?: Company;

  businessVerifiedCompanyBackgroundChecksMap?: BVCompanyBackgroundChecksMap;
  collapse: boolean = true;

  addressMap: Map<string, string | null> = new Map([
    ['Not Required', null],
    ['Verified', 'Verified']
  ]);

  governmentWatchListMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['None Allowed', 0]
    // ['All Watchlist(s)', 1]
  ]);

  sosMap: Map<string, string | null> = new Map([
    ['Not Required', null],
    ['In Good Standing', 'In Good Standing'],
    ['Inactive', 'Inactive']
  ]);

  corporateLiensJudgementsMap: Map<string, number | null> =
    this.UtilityService.setCoverageAmounts(
      10000,
      10000,
      1000000,
      new Map([['Not Required', null]]),
      new Map([['0 - $5,000', 5000]])
    );

  corporateBankruptcySearchMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['Not Allowed', 0],
    ['1 Year', 1],
    ['2 Years', 2],
    ['3 Years', 3],
    ['4 Years', 4],
    ['5 Years', 5],
    ['6 Years', 6],
    ['7 Years', 7]
  ]);

  requesterMatchingVendorMap: Map<string, string | null> = new Map([
    ['Not Required', null],
    ['Matching', 'Matching'],
    ['Likely Matching', 'Likely Matching'],
    ['Not Matching', 'Not Matching']
  ]);

  businessVerifiedSelectionMap: Map<string, boolean> = new Map([
    ['Matches IRS Records', true],
    ['Not Required', false]
  ]);

  keyValuePairDefaultOrder(
    a: KeyValue<any, any>,
    b: KeyValue<any, any>
  ): number {
    return 0;
  }

  getOptionValue(option: any): any {
    return option.value && typeof option.value === 'object'
      ? option.value.value
      : option.value;
  }

  loadBusinessVerifiedCompanyBackgroundChecksMapFields() {
    this.businessVerifiedCompanyBackgroundChecksMap = new Map([
      [
        'Legal Name Matches Tax ID',
        {
          controlName: 'businessVerified',
          inputType: 'Select',
          selectOptions: this.businessVerifiedSelectionMap,
          show: true
        }
      ],
      [
        'Address',
        {
          controlName: 'address',
          inputType: 'Select',
          selectOptions: this.addressMap,
          show: true
        }
      ],
      [
        'Government Watchlist',
        {
          controlName: 'governmentWatchlist',
          inputType: 'Select',
          selectOptions: this.governmentWatchListMap,
          show: true
        }
      ],
      [
        'Secretary of State',
        {
          controlName: 'secretaryOfState',
          inputType: 'Select',
          selectOptions: this.sosMap,
          show: true
        }
      ],
      [
        'Corporate Liens & Judgements',
        {
          controlName: 'liens',
          inputType: 'Select',
          selectOptions: this.corporateLiensJudgementsMap,
          show: true
        }
      ],
      [
        'Corporate Bankruptcy Search',
        {
          controlName: 'bankruptcy',
          inputType: 'Select',
          selectOptions: this.corporateBankruptcySearchMap,
          show: true
        }
      ],
      [
        'W9 Check',
        {
          controlName: 'isW9Checked',
          inputType: 'Checkbox',
          checkBoxLabel: 'Required?',
          show: true
        }
      ],
      [
        'Requester Matching Vendor',
        {
          controlName: 'requester',
          inputType: 'Select',
          selectOptions: this.requesterMatchingVendorMap,
          show: true
        }
      ]
    ]);
  }

  ngOnChanges(SimpleChanges: SimpleChanges): void {
    this.loadBusinessVerifiedCompanyBackgroundChecksMapFields();
  }

  // ngOnInit(): void {
  //   this.loadBusinessVerifiedCompanyBackgroundChecksMapFields();
  // };
}
